<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listExecutivePositions"
        :title-table="$t('Executive Positions')"
        module="executivePositionsSettingsModule"
        sort-name="nome"
        :show-btn-add="verificarPermissao('ROLE_ADMIM_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_ADMIM_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormExecutivePosition v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormExecutivePosition from './forms/FormExecutivePosition.vue'
import { verificarPermissao } from '@/auth/utils'

export default {
  name: 'ExecutivePosition',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormExecutivePosition
  },
  computed: {
    ...mapState('executivePositionsSettingsModule', {
      listExecutivePositions: (state) => state.listExecutivePositions
    })
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id'
        },
        {
          label: this.$t('Description'),
          field: 'nome'
        },
        {
          label: this.$t('Active'),
          field: 'ativo'
        },
        {
          label: this.$t('Action'),
          field: 'action'
        }
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'nome',
        order: 'asc'
      }
    }
  },
  mounted() {
    this.$store.dispatch(
      'executivePositionsSettingsModule/loadTable',
      this.pageConfig
    )
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'executivePositionsSettingsModule/prepareToEditExecutivePositions',
        data
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
      this.$store.dispatch(
        'executivePositionsSettingsModule/loadTable',
        this.pageConfig
      )
    }
  }
}
</script>
